import { memo } from 'react';
import { Badge, Card } from '@aimsos/ui';

const CHIP_CLASS =
  '!ml-0 !h-5 !border-[rgba(167,139,250,0.24)] !bg-[rgba(167,139,250,0.08)] !px-[9px] !py-0 !text-[10.5px] !font-bold !leading-none !tracking-[0.02em] !text-[#A78BFA]';

/**
 * Prototype `.cap-grp` — type header (colored icon + label + count + active chip)
 * and the read-only body (list rows, blurb, or "not supported").
 */
function CapabilityGroupCard({
  title,
  icon: Icon,
  iconClassName,
  countLabel,
  activeChip,
  supported,
  children,
}) {
  return (
    <Card className={supported ? 'overflow-hidden' : 'overflow-hidden opacity-40'}>
      <Card.Body className="px-[18px] py-0">
        <div className="flex items-center gap-2.5 pb-2.5 pt-3.5">
          <div
            aria-hidden="true"
            className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md ${iconClassName}`}
          >
            <Icon size={14} strokeWidth={2} />
          </div>
          <h3 className="min-w-0 flex-1 text-[13px] font-semibold text-content">{title}</h3>
          {supported && countLabel ? (
            <span className="shrink-0 text-[11px] text-content-secondary">{countLabel}</span>
          ) : null}
          {supported && activeChip ? (
            <Badge variant="purple" size="small" radius="md" className={CHIP_CLASS}>
              {activeChip}
            </Badge>
          ) : null}
          {!supported ? (
            <span className="shrink-0 text-[11px] text-content-secondary">{activeChip}</span>
          ) : null}
        </div>
        {supported && children ? (
          <div className="mt-1 border-t border-edge pb-3.5 pt-1">{children}</div>
        ) : null}
      </Card.Body>
    </Card>
  );
}

export default memo(CapabilityGroupCard);
